import * as yup from 'yup'

export const schemaTax = yup.object().shape({
  name: yup.string().required(),
  value: yup
    .number()
    .typeError('O valor precisa ser um número')
    .required('O valor é obrigatório')
    .positive()
    .min(0)
    .max(100),
  scope: yup.string().required(),
})

export default schemaTax
